/*!
 * /assets/delivery-date.js
 * Re-inits datepicker in AJAX cart drawer + writes to both cart attributes and cart note.
 */
(() => {
  "use strict";

  const DATE_INPUT_ID = "CartDrawer-delivery-date";
  const NOTE_TEXTAREA_ID = "CartDrawer-Note";
  const NOTE_PREFIX = "Delivery date: ";

  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const stripPreviousDeliveryLine = (note) => {
    if (!note) return "";
    const re = new RegExp("^" + escapeRegExp(NOTE_PREFIX) + ".*(?:\\r?\\n)?", "im");
    return String(note).replace(re, "").trim();
  };

  const buildNote = (existingNote, dateText) => {
    const cleaned = stripPreviousDeliveryLine(existingNote);
    const line = NOTE_PREFIX + dateText;
    return cleaned ? `${line}\n${cleaned}` : line;
  };

  const saveDate = async (dateText) => {
    if (!dateText) return;

    const noteEl = document.getElementById(NOTE_TEXTAREA_ID);
    const currentNote = noteEl ? noteEl.value : "";
    const nextNote = buildNote(currentNote, dateText);

    if (noteEl) noteEl.value = nextNote;

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { date: dateText },
        note: nextNote,
      }),
    }).catch(() => {});
  };

  const ensureDatepicker = (input) => {
    if (!window.jQuery?.fn?.datepicker) return false;

    const $ = window.jQuery;
    const $el = $(input);

    if ($el.hasClass("hasDatepicker")) return true;

    $el.datepicker({
      minDate: 1,
      maxDate: "+2M",
      onSelect: (dateText) => {
        input.value = dateText;
        saveDate(dateText);
      },
    });

    return true;
  };

  const initOnce = (input) => {
    if (input.dataset.deliveryDateInit === "1") return;
    input.dataset.deliveryDateInit = "1";

    // Prevent iOS zoom (in case theme overrides)
    input.style.fontSize = "16px";

    input.addEventListener("click", () => {
      if (window.jQuery?.fn?.datepicker && window.jQuery(input).hasClass("hasDatepicker")) {
        window.jQuery(input).datepicker("show");
      }
    });

    input.addEventListener("change", () => saveDate(input.value));

    // jQuery UI may load after; retry briefly
    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      if (ensureDatepicker(input) || tries > 30) clearInterval(t);
    }, 150);
  };

  const attach = () => {
    const input = document.getElementById(DATE_INPUT_ID);
    if (!input) return;
    initOnce(input);
  };

  const observeDrawer = () => {
    const drawer = document.getElementById("CartDrawer");
    if (!drawer) return;

    new MutationObserver(() => attach()).observe(drawer, {
      childList: true,
      subtree: true,
    });
  };

  const boot = () => {
    attach();
    observeDrawer();
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
